import { Component } from 'react';

class InsertTableComponent extends Component {
    render() {
        let { _pageScope, moduleId, headItems, bodyItems, ...others } = this.props;
        others.headTableId = moduleId;
        others.bodyTableId = bodyItems?.code;
        if(typeof others.setTableBodyData !== 'function'){
            others.setTableBodyData = record=> {
                _pageScope.props.insertTable.setChildTableData(
                    moduleId,
                    record,
                    {
                        rows:[{
                            status: 0,
                            values:  headItems.value.reduce((memo, x)=>{
                                memo[x.attrcode] = { display: x.label, value: x.attrcode };
                                return memo;
                            }, {}),
                        }],
                    },
                    bodyItems?.value?.[0]?.attrcode || 'id',
                ); 
            };
        }
        return _pageScope.props.insertTable.createInsertTable(others);
    }
}

export default InsertTableComponent;